import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class AppConfig {
  private config: Object = null;

  constructor(private http: HttpClient) {
  }

  public getConfig(key: any) {
    return this.config[key];
  }

  public load() {
    return new Promise((resolve) => {
      let midURL: string;

      this.http.get('./assets/env/env.json')
        .pipe(
          map((res: any) => res),
          catchError((error) => {
            console.error('Configuration file "env.json" could not be read');
            return of(true);
          })
        )
        .subscribe((envResponse) => {
          switch (envResponse.env) {
            case 'production': {
              midURL = 'production';
            } break;

            case 'development': {
              midURL = 'development';
            } break;

            case 'default': {
              console.error('Environment file is not set or invalid');
              resolve(true);
            } break;

          }

          this.http.get('./assets/env/env.' + midURL + '.json')
            .pipe(
              map((res: any) => res),
              catchError((error) => {
                console.error('Configuration file "env.---.json" could not be read');
                return of(true);
              })
            )
            .subscribe((responseData: any) => {
              this.config = responseData;
              resolve(true);
            });

        });
    });

  }

}
